// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer{display:flex;justify-content:center}", "",{"version":3,"sources":["webpack://./widget/tint/theme/src/components/footer/footer.sass"],"names":[],"mappings":"AAAA,QACE,YAAA,CACA,sBAAA","sourcesContent":[".footer\n  display: flex\n  justify-content: center"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
